import mustache from 'mustache';
import { msgList } from './resources/msgList';

export default class Message {
  /**
   * メッセージ文にパラメータを埋め込んで返却
   */
  public static get(message: string, ...args: any[]): string {
    const msg = this.find(message) || { TEXT: '' };
    if (args.length === 1 && args[0] instanceof Object) {
      return mustache.render(msg.TEXT, args[0]);
    }
    return mustache.render(msg.TEXT, args);
  }

  /**
   * メッセージ一覧
   */
  private static readonly messageList: Array<{
    CD: string;
    TEXT: string;
    TYP: string;
  }> = msgList;

  /**
   * コードを元にメッセージオブジェクトを検索
   */
  private static find(cd: string) {
    return this.messageList.find((e: any) => e.CD === cd);
  }
}
